import React from "react";
import "./styles.scss"

function Loading(){
return(
    <div className="loading"> <div className="loader">
        
    </div></div>
   
)
}

export default Loading